var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10816",
    "data-name": "Group 10816",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17900",
    "data-name": "Rectangle 17900",
    width: 18,
    height: 18,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10814",
    "data-name": "Group 10814",
    transform: "translate(1.002 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    transform: "translate(0.849 0) rotate(4)",
    fill: "none",
    stroke: "#455079",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.085,
    cy: 6.085,
    rx: 6.085,
    ry: 6.085,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.085,
    cy: 6.085,
    rx: 5.085,
    ry: 5.085,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M0,0,4.521,2.329",
    transform: "translate(10.962 10.854) rotate(13)",
    fill: "none",
    stroke: "#455079",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDark);
export default __webpack_public_path__ + "static/media/search-dark.2bbc1b879344332df8fe5069c29d0feb.svg";
export { ForwardRef as ReactComponent };